export default __webpack_public_path__ + "static/media/399.4243ceb3.gif";